import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MemberQuery, PopulationQuery } from '@fgb/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { calculateAge, getKidType, KidTypeT } from 'src/app/shared/utilities/age-ranges';
import { Populations } from 'src/app/shared/utilities/populations';
import { Tags } from 'src/app/shared/utilities/tags';

@Component({
  selector: 'fgb-games-page',
  templateUrl: './games-page.component.html',
  styleUrls: ['./games-page.component.scss'],
})
export class GamesPageComponent implements OnInit {
  populations = Populations;
  tags = Tags;
  memberInfo$: Observable<{ kidType: KidTypeT }>;
  isKid: boolean;
  isMember: boolean;
  isAdultMember: boolean;
  isClub1901: boolean;
  isSTH: boolean;
  isSTHKid: boolean;
  isMemberKid: boolean;

  constructor(
    private populationQuery: PopulationQuery,
    private memberQuery: MemberQuery,
    private router: Router
  ) {}

  ngOnInit() {
    this.memberInfo$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => {
        if (m) {
          const age = calculateAge(new Date(m.DOB));
          return { kidType: getKidType(age) };
        }
        return { kidType: 'Other' as KidTypeT };
      })
    );
    this.isKid = this.populationQuery.userInPopulation([this.populations.Kids]);
    this.isMember = this.populationQuery.userInPopulation([this.populations.Default]);
    this.isClub1901 = this.populationQuery.userInPopulation([this.populations.Club1901]);
    const userContext = this.memberQuery.getUserContext();
    const customerTags = userContext.customerTags;
    const isKidsPopulation = this.populationQuery.userInPopulation([this.populations.Kids]);
    this.isAdultMember = customerTags?.some((t) => t.TagName === Tags.Member.TagName) ?? false;
    this.isSTHKid = isKidsPopulation && (customerTags?.some((t) => t.TagName === Tags.JuniorSTH.TagName) ?? false);
    this.isMemberKid = isKidsPopulation && (customerTags?.some((t) => t.TagName === Tags.JuniorMembers.TagName) ?? false);
  }

  navigateToPaP() {
    this.router.navigate(['/games/pickaplayer']);
  }
}
